<template>
  <div class="console_r">
    <!-- <sub-header :id="queryParams.hennery_id" name="audio"></sub-header> -->
    <div class="console_r_card">
      <div class="title">
        <b>{{currHenneryName}} - 声音列表<i @click="refresh" class="el-icon-refresh" title="刷新"></i></b>
        <span>当前记录：{{count}}</span>
      </div>
      <div class="con">
        <div class="con_top" style="padding: 20px 0;">
          <!-- <el-input type="input" style="width: 200px" v-model="queryParams.device_id" placeholder="请输入设备ID"></el-input> -->
          <el-select v-model="queryParams.building_id" style="width: 135px">
            <el-option value="" label="全部分栋">全部分栋</el-option>
            <el-option v-for="(item, index) in buildings" :key="index" :label="item.name" :value="item.id"></el-option>
          </el-select>
          <el-select v-model="queryParams.device_id" style="width: 135px">
            <el-option value="" label="全部设备">全部设备</el-option>
            <el-option v-for="(item, index) in devices" :key="index" :label="item.name" :value="item.id"></el-option>
          </el-select>
          <el-select v-model="queryParams.audio_type" @change="audioTypeChange" style="width: 135px">
            <el-option value="" label="全部类型">全部类型</el-option>
            <el-option v-for="(item, index) in isShowBuzzAudioType" :key="index" :label="item.key" :value="item.value"></el-option>
          </el-select>
          <el-select v-model="queryParams.sub_type" style="width: 135px" :disabled="queryParams.audio_type === ''">
            <el-option value="" label="全部子类型">全部子类型</el-option>
            <el-option v-for="(item, index) in currSubTypeList" :key="index" :label="item.key" :value="item.value"></el-option>
          </el-select>
          <el-select v-model="queryParams.filter_remark" style="width: 135px">
            <!-- <el-option value="" label="全部">全部</el-option> -->
            <el-option v-for="(item, index) in filterTypeList" :key="index" :label="item.name" :value="item.value"></el-option>
          </el-select>
          <el-input type="input" style="width: 135px" @input="inputValue" v-model="queryParams.conf_min_threshold" placeholder="置信值≥" clearable></el-input>
          <el-date-picker
            style="width: 280px"
            v-model="startTime"
            type="datetime"
            placeholder="选择开始时间">
          </el-date-picker>
          <el-date-picker
            style="width: 280px"
            v-model="endTime"
            type="datetime"
            placeholder="选择结束时间">
          </el-date-picker>
          <!-- <el-date-picker
            v-model="dateTimeFilter"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :editable="false"
            size="large"
            @change="dateChange"
            align="right">
          </el-date-picker> -->
          <el-input type="input" style="width: 280px" v-model="queryParams.keyword" placeholder="文件名或备注" clearable></el-input>
          <el-button type="primary" @click="search" round>查询</el-button>
        </div>
        <div style="padding-bottom: 5px;">
          <el-button 
          type="danger" 
          size="mini" 
          slot="reference" 
          :disabled="multipleSelection.length <= 0" 
          @click="batchDeleteAbnormal"
          round>批量删除</el-button>
        </div>
        <el-table 
        style="width: 100%" 
        ref="multipleTable"
        :data="list" 
        @selection-change="handleSelectionChange"
        border>
          <el-table-column type="selection" width="55"></el-table-column>
          <!-- <el-table-column prop="id" label="ID" width="80"></el-table-column> -->
          <el-table-column prop="building_name" label="分栋"></el-table-column>
          <el-table-column prop="name" label="设备昵称" width="80"></el-table-column>
          <el-table-column prop="audio_name" label="文件名" min-width="110" width="230"></el-table-column>
          <el-table-column label="开始时间" min-width="110" width="168">
            <template slot-scope="scope">
              <span style="white-space: nowrap; padding-right: 5px">{{ scope.row.monitor_start2.split(' ')[0] }}</span>
              <span style="white-space: nowrap">{{ scope.row.monitor_start2.split(' ')[1] }}</span>
            </template>
          </el-table-column>
          <el-table-column label="结束时间" min-width="110" width="168">
            <template slot-scope="scope">
              <span style="white-space: nowrap; padding-right: 5px">{{ scope.row.monitor_end2.split(' ')[0] }}</span>
              <span style="white-space: nowrap">{{ scope.row.monitor_end2.split(' ')[1] }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="audio_type_text" label="类型"></el-table-column>
          <el-table-column label="子类型" min-width="100">
            <template slot-scope="scope">
              <span>{{scope.row.sub_type_text}}
                <el-tooltip v-if="scope.row.sub_type>=10" class="item" effect="light" :content="scope.row.sub_type_des" placement="right">
                  <i @click="refresh" class="el-icon-question" title=""></i>
                </el-tooltip>
              </span>
            </template>
          </el-table-column>
          <el-table-column prop="conf2" label="置信值"></el-table-column>
          <el-table-column prop="remark_comment" label="备注"></el-table-column>
          <el-table-column prop="audio_bytes2" label="大小(KB)" width="110"></el-table-column>
          <el-table-column prop="audio_duration" label="时长(秒)" width="110"></el-table-column>
          <el-table-column label="创建时间" min-width="110" width="168">
            <template slot-scope="scope">
              <span style="white-space: nowrap; padding-right: 5px">{{ scope.row.created_at2.split(' ')[0] }}</span>
              <span style="white-space: nowrap">{{ scope.row.created_at2.split(' ')[1] }}</span>
            </template>
          </el-table-column>
          <el-table-column width="410px" label="操作" fixed="right">
              <template slot-scope="scope">
                <el-button 
                type="primary" 
                size="mini" 
                @click="normalizePlay(scope.row, 0, true)"
                circle>
                  <i :class="`iconfont ${currPlayStatus === 'running' && scope.row.id === currMp3Index && currPlayAudioPathType === 0 ? 'icon-zanting1' : 'icon-bofang1'}`" style="font-size: 12px;"></i>
                </el-button>
                <!-- <el-button 
                type="primary" 
                size="mini" 
                v-if="scope.row.id === currMp3Index && currPlayAudioPathType === 1"
                @click="normalizeClose(scope.row)"
                circle>
                  <i class="iconfont icon-zanting1" style="font-size: 12px;"></i>
                </el-button> -->
                <el-button type="primary" size="mini" @click="getSpectrogram(scope.row, 0)" round>频谱图</el-button>
                <el-button type="warning" size="mini" @click="getSpectrogram(scope.row, 1)" :disabled="scope.row.sick_extra_start===scope.row.sick_extra_end" round>上下文</el-button>
                <el-button type="primary" size="mini" @click="download(scope.row)" round>下载</el-button>
                <el-button type="danger" size="mini" @click="viewDetail(scope.row)" round>修改</el-button>
                <el-popconfirm
                style="margin-left:10px;"
                @confirm="deleteAbnormal(scope.row.id)"
                title="确定删除？">
                  <el-button type="danger" size="mini" slot="reference" round>删除</el-button>
                </el-popconfirm>
              </template>
            </el-table-column>
        </el-table>
      </div>
      <div style="text-align: center">
        <el-pagination
        style="padding: 20px 0 40px"
        background
        layout="sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="currPageChange"
        :page-sizes="[10, 20, 30, 50, 100]"
        :page-size="queryParams.limit"
        :current-page.sync="currPage"
        :total="count">
        </el-pagination>
      </div>
    </div>
    <!--弹框-->
    <el-dialog 
    class="dialog"
    title="修改" 
    width="600px"
    :visible.sync="deviceDialogVisible">
      <div class="detail-item">
        <div class="audio-icon">
          <i :class="`${currPlayStatus === 'running' && currViewDetailData.id === currMp3Index && currPlayAudioPathType === 0 ? 'el-icon-video-pause' : 'el-icon-video-play'}`" @click="normalizePlay(currViewDetailData, 0, true)"></i>
          <!-- <i class="el-icon-video-pause" v-if="currViewDetailData.id===currMp3Index && currPlayAudioPathType === 1" @click="normalizeClose(currViewDetailData)"></i> -->
        </div>
        <el-form ref="editPostParams" :model="editPostParams" label-width="140px">
          <el-form-item label="类型">
            <el-select v-model="editPostParams.audio_type" placeholder="请选择" style="width: 100%" @change="audioTypeChange">
              <el-option v-for="item in isShowBuzzAudioType" :key="item.value" :label="item.key" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="子类型">
            <el-select v-model="editPostParams.sub_type" placeholder="请选择" style="width: 100%">
              <el-option v-for="item in currEditSubTypeList" :key="item.value" :label="item.key" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="备注：">
            <el-input type="textarea" :rows="2" v-model="editPostParams.remark_comment" placeholder="请输入备注内容"></el-input>
          </el-form-item>
        </el-form>
        <div style="text-align: right;">
          <el-button 
          type="primary"
          @click="modifyAbnormal(currViewDetailData.id)" 
          >修 改</el-button>
        </div>
      </div>
    </el-dialog>
    <el-dialog 
    class="dialog"
    :title="currAudioPathType===1 ? '上下文' : '频谱图'" 
    :width="`${spectrogramDialogWidth}px`"
    :top="`${spectrogramDialogTop}px`"
    :visible.sync="spectrogramDialogVisible"
    @close="spectrogramDialogClose">
      <div class="detail-item">
        <div class="audio-icon">
          <div class="audio-pro">
            <div class="audio-pro-left" :style="{width: `${spectrogramVernierStart}%`}"></div>
            <div class="audio-pro-center" :style="{width: `${spectrogramVernierEnd - spectrogramVernierStart}%`}">
              <div ref="slider" class="slider" 
              @mousedown="sliderMouseDown" 
              @mousemove="sliderMouseMove" 
              @mouseup="sliderMouseUp"
              @mouseleave="sliderMouseLeave">
                <div class="bar" :style="{width: `${showAudioPlayProgress}%`}"></div>
                <div class="btn" :style="{left: `${showAudioPlayProgress}%`}" @mousedown="sliderBtnMouseDown" @mouseup="sliderBtnMouseUp"><i></i></div>
              </div>
              <div class="audio-progress-txt">{{currAudioPlayProgressTxt}}</div>
            </div>
            <div class="audio-pro-right">
              <i :class="`${currPlayStatus === 'running' && currViewDetailData.id === currMp3Index && currPlayAudioPathType === currAudioPathType ? 'el-icon-video-pause' : 'el-icon-video-play'}`" 
              @click="normalizePlay(currViewDetailData, currAudioPathType)"></i>
            </div>
          </div>
        </div>
        <!-- <test :url="spectrogramAudioUrl"></test> -->
        <div class="audio-spectrogram">
          <el-image style="width: 100%" fit="contain" :src="`data:image/jpg;base64,${spectrogramBase64}`"></el-image>
          <!-- <div class="audio-spectrogram-region"></div> -->
          <!-- <div class="audio-interest-region" :style="{left: `${audioInterestRegionLeft}%`, bottom: `${audioInterestRegionBottom}%`, width: `${audioInterestRegionWidth}%`, height: `${audioInterestRegionHeight}%`}"></div> -->
          <div class="audio-vernier" :style="{left: `${spectrogramVernierLeft}%`}"></div>
          <div class="audio-region" v-if="showAudioRegion" :style="{width: `${audioRegionWidth}%`, left: `${audioRegionLeft}%`}"></div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { Message } from 'element-ui';
import moment from '@/libs/moment'
import { getAbnormalListApi, getAbnormalCountApi, modifyAbnormalApi, spectrogramApi, downloadAudio, getDevicesApi, getBuildingListApi, deleteAbnormalApi, batchDeleteAbnormalApi, getAudioUrlApi } from '@/api/user'
import config from '@/config'
// import ShAudio from '@/components/Audio'
// import Test from '@/components/Test2'
import SubHeader from '@/components/SubHeader'
import normalize from '@/libs/normalize'

export default {
  name: 'Audio',
  components: {
    // ShAudio
    // Test
    // SubHeader
  },
  data() {
    return {
      currHenneryName: '',
      queryParams: {
        skip: 0,
        limit: 10,
        building_id: '',
        device_id: '',
        audio_type: '',
        sub_type: '',
        keyword: '',
        filter_remark: 0,
        conf_min_threshold: '',
        start_time: null,
        end_time: null,
        hennery_id: Number(this.$route.params.id)
      },
      startTime: null,
      endTime: null,
      list: [],
      count: 0,
      currPage: 1,
      dateTimeFilter: '',
      filterTypeList: [
        {
          name: '全部状态',
          value: 0
        },
        {
          name: '未处理',
          value: 1
        },
        {
          name: '已处理',
          value: 2
        },
        {
          name: '待审核',
          value: 3
        }
      ],
      deviceDialogVisible: false,
      deviceAudioData: null,
      deviceAudioParams: {
        start_time: null,
        end_time: null,
        device_id: null,
        limit: 10000
      },
      currDate: '',
      oneDayTime: 24 * 60 * 60 * 1000,
      timeNumConfig: {
        itemWidth: 5,  // 一条数据的宽度（目前5分钟一条数据）
        scaleInterval: 120  // 多少分钟一个刻度
      },
      // currAudioUrl: '',
      currMp3Index: null,
      currMp3Url: null,
      currAudioPlayProgress: 0,
      showAudioPlayProgress: 0,
      currAudioPlayProgressTxt: '0:00 / 0:00',
      currAudioDuration: 0,
      currAudioPathType: 0,  // 0: audio_path  1: sick_extra_path
      currPlayAudioPathType: 0,  // 0:频谱图  1:上下文
      currPlayTime: 0,
      currPlayStatus: '',  // running：播放中，suspended：暂停，ended：播放结束
      statusBeforeUpdateProgress: '',
      sliderIsMouseDown: false,
      sliderBtnIsDown: false,
      sliderBtnMoveStartPx: 0,
      sliderBtnMoveEndPx: 0,
      sliderBtnMovePx: 0,
      sliderLen: 0,
      sliderBtnMoveLen: 0,
      currSubTypeList: [],
      currEditSubTypeList: [],
      audioType: config.audioType,
      editPostParams: {
        audio_type: null,
        sub_type: -2,
        remark_comment: null,
      },
      currViewDetailData: {
        id: null,
        audio_name: null,
        audio_type: null,
        remark_comment: null,
        audio_path: null
      },
      spectrogramDialogVisible: false,
      spectrogramDialogWidth: 760,
      spectrogramDialogTop: 0,
      spectrogramAudioUrl: '',
      spectrogramBase64: '',
      spectrogramVernierLeft: 12.7,
      spectrogramVernierStart: 12.7,
      spectrogramVernierEnd: 74.7,
      spectrogramVernierTimer: null,
      devices: [],
      buildings: [],
      multipleSelection: [],
      newNormalizeAudio: null,
      audioRegionWidth: 0,
      audioRegionLeft: 0,
      showAudioRegion: false,
      audioInterestRegionLeft: 0,
      audioInterestRegionBottom: 0,
      audioInterestRegionWidth: 0,
      audioInterestRegionHeight: 0
    }
  },
  computed: {
    isShowBuzzAudioType () {
      let showBuzz = this.$store.state.user.showBuzz
      let at = [...this.audioType]
      if(showBuzz) {
        at.splice(3, 0, {
          key: '电流音',
          value: -3,
          subType: [
            {
              key: '默认',
              value: -2
            },
          ]
        })
      }
      return at
    },
  },
  methods: {
    audioTypeChange (e) {
      if(this.deviceDialogVisible) {
        this.editPostParams.sub_type = -2
      } else {
        this.queryParams.sub_type = ''
      }
      this.isShowBuzzAudioType.forEach(item => {
        if(item.value == e) {
          if(this.deviceDialogVisible) {
            this.currEditSubTypeList = item.subType
          } else {
            this.currSubTypeList = item.subType
          }
        }
      })
    },
    inputValue (e) {
      if(e > 1 || e < 0) {
        Message.error('置信值范围0~1')
        this.queryParams.conf_min_threshold = ''
        return
      }
      let value = e.replace(/[^0-9.]/g, '') // 只能输入数字和小数点
                  .replace(/^\./g, '') // 保证第一个不能是小数点
                  .replace(/\.{2,}/g, '.') // 不能连续出现多个小数点
                  .replace('.', '$#$').replace(/\./g, '').replace('$#$', '.') // 保证只能一个小数点
                  // .replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3')  // 保证只能输入两个小数    
      this.queryParams.conf_min_threshold = value
    },
    toggleSelection(rows) {
      if (rows) {
        rows.forEach(row => {
          this.$refs.multipleTable.toggleRowSelection(row);
        });
      } else {
        this.$refs.multipleTable.clearSelection();
      }
    },
    handleSelectionChange (val) {
      this.multipleSelection = []
      val.forEach(v => {
        this.multipleSelection.push(v.id.toString())
      })
    },
    handleSizeChange (val) {
      this.queryParams.limit = val
      this.refresh()
    },
    download (row) {
      const _this = this
      // await this.getAudioUrl(row.id, 0)
      fetch(row.audio_path).then(data => {
        // console.log(data)
        const blob = data.blob()
        return blob
      }).then(blob => {
        // console.log(blob)
        // let url = window.URL.createObjectURL(blob)
        let url = window.URL.createObjectURL(new Blob([blob], { type: "application/octet-stream" }));
        // console.log('url', url)
        const a = document.createElement('a')
        a.href = url
        a.download = row.audio_name
        document.body.appendChild(a)
        a.click()
        document.body.removeChild(a)
      })
    },
    /**
     * pathType  0: audio_path  1: sick_extra_path
     */
    getSpectrogram (row, pathType) {
      this.currAudioPathType = pathType
      if(pathType === 1) {
        if(row.sick_extra_start === row.sick_extra_end) return
        this.currMp3Url = row.sick_extra_path
      } else {
        this.currMp3Url = row.audio_path
      }
      // await this.getAudioUrl(row.id, pathType)
      spectrogramApi({source_url: this.currMp3Url}).then(res=>{
        let data = res.data.data
        let bodyH = document.body.offsetHeight
        // 弹框中间内容高度708，根据此高度计算top
        let top = (bodyH - 708)/2
        this.currViewDetailData.id = row.id
        this.spectrogramDialogVisible = true
        this.spectrogramBase64 = data.image
        this.currAudioDuration = data.duration
        this.spectrogramDialogTop = top < 0 ? 0 : top
        if(pathType === 1) {
          let spectrogramWidth = this.spectrogramVernierEnd-this.spectrogramVernierStart
          this.audioRegionLeft = (((row.audio_start - row.sick_extra_start)/1000)/data.duration) * spectrogramWidth + this.spectrogramVernierStart
          this.audioRegionWidth = (row.audio_duration/data.duration) * spectrogramWidth
          this.showAudioRegion = true
          // if(row.extra_audio_duration) {
          //   let spectrogramWidth = this.spectrogramVernierEnd-this.spectrogramVernierStart
          //   this.audioRegionLeft = (((row.audio_start - row.sick_extra_start)/1000)/row.extra_audio_duration) * spectrogramWidth + this.spectrogramVernierStart
          //   this.audioRegionWidth = (row.audio_duration/row.extra_audio_duration) * spectrogramWidth
          //   this.showAudioRegion = true
          // }
        } else {
          let xAxisLen = 499, yAxisLen = 128, sBottomPer = 11, sTopPer = 77, 
              sWidthPer = this.spectrogramVernierEnd-this.spectrogramVernierStart, sHeightPer = sTopPer - sBottomPer
          let xy = [300, 100, 350, 70], xLen = Math.abs(xy[0] - xy[2]), yLen = Math.abs(xy[1] - xy[3]), xStart = Math.min(xy[0], xy[2]), yStart = Math.min(xy[1], xy[3])
          let xLenPer = xLen/xAxisLen * sWidthPer, yLenPer = yLen/yAxisLen * sHeightPer, xStartPer = xStart/xAxisLen * sWidthPer, yStartPer = yStart/yAxisLen  * sHeightPer
          this.audioInterestRegionLeft = this.spectrogramVernierStart + xStartPer
          this.audioInterestRegionBottom = sBottomPer + yStartPer
          this.audioInterestRegionWidth = xLenPer
          this.audioInterestRegionHeight = yLenPer
        }
        if(this.currMp3Index !== this.currViewDetailData.id || this.currPlayAudioPathType !== this.currAudioPathType) {
          this.currAudioPlayProgress = 0
        }
        this.initspectrogramVernier(this.currAudioPlayProgress/100, true)
      }).catch(() => {
        Message.error('获取频谱图失败')
      })
    },
    spectrogramDialogClose () {
      this.showAudioRegion = false
      if(this.currPlayAudioPathType === 1) {
        this.currMp3Index = null
        this.currMp3Url = null
        if(this.newNormalizeAudio) {
          this.newNormalizeAudio.close()
          this.newNormalizeAudio = null
        }
        this.initspectrogramVernier(0, true)
      }
    },
    initspectrogramVernier (progress, isSetProgress) {
      let p = 0
      // 解决边界溢出
      if(progress < 0) {
        p = 0
      } else if(progress > 1) {
        p = 1
      } else {
        p = progress
      }
      if(isSetProgress) {
        this.currAudioPlayProgress = p * 100
      }
      this.showAudioPlayProgress = p * 100
      this.spectrogramVernierLeft = this.spectrogramVernierStart + ((this.spectrogramVernierEnd - this.spectrogramVernierStart) * p)
      this.formatPlayProgressTxt(p)
    },
    formatSecondToMinute (val) {
      let txt = ''
      const addZero = (v) => {
        return v < 10 ? `0${v}` : v
      }
      if (val < 60) {
        txt = `0:${addZero(val)}`
      } else if (val >= 60) {
        let m = Math.floor(val/60), s = val - m*60
        txt = `${m}:${addZero(s)}`
      }
      return txt
    },
    formatPlayProgressTxt (progress) {
      let currProgress = this.currAudioDuration * progress
      this.currAudioPlayProgressTxt = this.formatSecondToMinute(Math.floor(currProgress)) + ' / ' + this.formatSecondToMinute(this.currAudioDuration)
    },
    handleMouseDown () {
      console.log(1)
      this.sliderIsMouseDown = true
    },
    handleMouseUp () {
      console.log(2)
      this.sliderIsMouseDown = false
    },
    sliderMouseDown (e) {
      this.sliderLen = this.$refs.slider.clientWidth
      if(this.statusBeforeUpdateProgress === 'running') {
        this.newNormalizeAudio.onlyPause()
        this.currPlayStatus = 'suspended'
      }
      if(this.sliderBtnIsDown) {
        this.sliderBtnMoveStartPx = e.x
      }
    },
    sliderMouseMove (e) {
      if(this.sliderBtnIsDown) {
        let movePx = e.x - this.sliderBtnMoveStartPx
        this.sliderBtnMoveLen = movePx / this.sliderLen * 100
        let allProgress = this.currAudioPlayProgress + this.sliderBtnMoveLen
        this.initspectrogramVernier(allProgress/100, false)
      }
    },
    sliderMouseUp (e) {
      if(!this.sliderBtnIsDown) {
        let sliderRef = this.$refs.slider
        this.currAudioPlayProgress = Math.floor(e.offsetX / sliderRef.clientWidth * 100)
        if(this.statusBeforeUpdateProgress === 'running') {
          this.newNormalizeAudio.offsetPlay(this.currAudioPlayProgress/100)
        }
      } else {
        this.currAudioPlayProgress += this.sliderBtnMoveLen
        this.sliderBtnMoveLen = 0
        if(this.statusBeforeUpdateProgress === 'running') {
          console.log('e.x - this.sliderBtnMoveStartPx', e.x - this.sliderBtnMoveStartPx)
          if(e.x - this.sliderBtnMoveStartPx !== 0) {
            this.newNormalizeAudio.offsetPlay(this.currAudioPlayProgress/100)
          } else {
            this.newNormalizeAudio.pause()
          }
          this.currPlayStatus = 'running'
        }
      }
      this.sliderBtnIsDown = false
      this.initspectrogramVernier(this.currAudioPlayProgress/100, true)
    },
    sliderMouseLeave (e) {
      if(this.sliderBtnIsDown) {
        this.currAudioPlayProgress += this.sliderBtnMoveLen
        this.sliderBtnMoveLen = 0
        this.sliderBtnIsDown = false
        this.initspectrogramVernier(this.currAudioPlayProgress/100, true)
        if(this.statusBeforeUpdateProgress === 'running') {
          if(e.x - this.sliderBtnMoveStartPx !== 0) {
            this.newNormalizeAudio.offsetPlay(this.currAudioPlayProgress/100)
          } else {
            this.newNormalizeAudio.pause()
          }
          this.currPlayStatus = 'running'
        }
      }
    },
    sliderBtnMouseDown (e) {
      this.sliderBtnIsDown = true
    },
    sliderBtnMouseUp (e) {
      console.log(22)
      // this.sliderBtnIsDown = false
    },
    async normalizePlay (row, type, isRePlay=false) {
      if(this.currMp3Index === row.id && this.currPlayAudioPathType === type) {
        if(this.currPlayStatus === 'running') {
          this.newNormalizeAudio.pause()
        } else {
          if(isRePlay) {
            this.newNormalizeAudio.offsetPlay(0)
          } else {
            this.newNormalizeAudio.offsetPlay(this.currAudioPlayProgress/100)
          }
        }
        return
      }
      this.initspectrogramVernier(0, true)
      this.currPlayAudioPathType = type
      this.currMp3Index = row.id
      // this.currPlayAudioPathType = type
      if(this.newNormalizeAudio) {
        this.newNormalizeAudio.close()
        this.newNormalizeAudio = null
      }
      // this.currMp3Index = row.id
      if(!this.spectrogramDialogVisible) {
        this.currMp3Url = row.audio_path
        // await this.getAudioUrl(row.id, 0)
      }
      this.newNormalizeAudio = new normalize(this.audioEnded)
      await this.newNormalizeAudio.play(this.currMp3Url, this.showAudioPlayProgress/100)
      // this.currAudioDuration = this.newNormalizeAudio.duration
      // this.formatPlayProgressTxt(this.currAudioPlayProgress)
      // this.spectrogramVernier(this.newNormalizeAudio.duration * 1000)
    },
    // normalizePause (row) {},
    // normalizeClose (row) {
    //   if (this.currMp3Index !== row.id) return
    //   this.currMp3Index = null
    //   this.newNormalizeAudio.close()
    //   this.newNormalizeAudio = null
    //   this.initspectrogramVernier()
    // },
    audioEnded (obj) {
      if(!this.newNormalizeAudio) return
      // console.log('newNormalizeAudio', this.newNormalizeAudio)
      // console.log('obj', obj)
      this.currPlayStatus = obj.status
      if(obj.status === 'running') {
        this.statusBeforeUpdateProgress = obj.status
      } else {
        this.statusBeforeUpdateProgress = ''
      }
      if(obj.currentTime) {
        this.currPlayTime = obj.currentTime
      }
      let progress = this.currPlayTime/this.currAudioDuration
      if(this.currMp3Index === this.currViewDetailData.id && this.currPlayAudioPathType === this.currAudioPathType) {
        this.initspectrogramVernier(progress, true)
      }
      if(obj.status === 'ended') {
        // 播放结束
        this.initspectrogramVernier(0, true)
        this.currMp3Index = null
        // this.currMp3Url = null
        this.newNormalizeAudio.close()
        this.newNormalizeAudio = null
      } else if (obj.status === 'running') {
        // 播放中
      } else if (obj.status === 'suspended') {
        // 暂停
      }
    },
    /**
     * isSick 1:sick
     */
    // async getAudioUrl (id, isSick) {
    //   await getAudioUrlApi(id, {hennery_id: this.queryParams.hennery_id, is_sick_path: isSick}).then(res=>{
    //     console.log('URL', res.data)
    //     this.currMp3Url = res.data.data.link
    //     // cb(res.data.data.link)
    //   }).catch(() => {
    //     Message.error('获取音频URL失败')
    //   })
    // },
    modifyAbnormal () {
      modifyAbnormalApi(this.currViewDetailData.id, {...this.editPostParams, hennery_id: this.queryParams.hennery_id}).then(res=>{
        let fileName = this.currViewDetailData.audio_name
        this.getList()
        this.getCount()
        for(let k in this.currViewDetailData) {
          this.currViewDetailData[k] = null
        }
        for(let k in this.editPostParams) {
          this.editPostParams[k] = null
        }
        Message.success(`${fileName} 修改成功`)
        this.deviceDialogVisible = false
      }).catch(() => {
        Message.error('修改失败')
      })
    },
    deleteAbnormal (id) {
      deleteAbnormalApi(id, this.queryParams.hennery_id).then(res=>{
        this.refresh()
        Message.success('删除成功')
      }).catch(() => {
        Message.error('删除失败')
      })
    },
    batchDeleteAbnormal () {
      batchDeleteAbnormalApi({
        hennery_id: this.queryParams.hennery_id,
        ids: this.multipleSelection
      }).then(res=>{
        this.refresh()
        Message.success('批量删除成功')
      }).catch(() => {
        Message.error('批量删除失败')
      })
    },
    getList () {
      getAbnormalListApi(this.queryParams).then(res=>{
        this.list = res.data.data.audios
        this.currHenneryName = res.data.data.hennery.name
        this.list.forEach((item) => {
          item.audio_end2 = moment(item.audio_end).format("YYYY-MM-DD HH:mm:ss")
          item.audio_start2 = moment(item.audio_start).format("YYYY-MM-DD HH:mm:ss")
          item.monitor_end2 = moment(item.monitor_end).format("YYYY-MM-DD HH:mm:ss")
          item.monitor_start2 = moment(item.monitor_start).format("YYYY-MM-DD HH:mm:ss")
          item.created_at2 = moment(item.created_at).format("YYYY-MM-DD HH:mm:ss")
          item.audio_duration = Math.round((item.audio_end - item.audio_start)/1000)
          item.extra_audio_duration = !!item.sick_extra_start ? Math.round((item.sick_extra_end - item.sick_extra_start)/1000) : 0
          item.audio_bytes2 = !!item.audio_bytes ? Math.round(item.audio_bytes/1024) : ''
          item.name = !!item.device_custom_name ? item.device_custom_name : item.device_hostname
          item.conf2 = !!item.conf ? item.conf : ''
          /**
           * remark_type === -2 时 音频类型是 audio_type
           * remark_type !== -2 时 音频类型是 remark_type
           */
          this.isShowBuzzAudioType.forEach(type => {
            // if(item.remark_type === -2 && item.audio_type === type.value) {
            //   item.audio_type_text = type.key
            // }
            // if(item.remark_type !== -2 && item.remark_type === type.value) {
            //   item.audio_type_text = type.key
            // }
            if(item.audio_type === type.value) {
              item.audio_type_text = type.key
              type.subType.forEach(st => {
                if(item.sub_type === st.value && item.sub_type !== -2) {
                  let text = st.key.split('-')
                  item.sub_type_text = text[0]
                  item.sub_type_des = text[1]
                }
              })
            }
          })
        })
        this.loadingData = false
      }).catch(() => {
        this.loadingData = false
      })
    },
    getCount () {
      getAbnormalCountApi(this.queryParams).then(res => {
        this.count = res.data.data.count
      })
    },
    refresh () {
      if(this.startTime) {
        this.queryParams.start_time = moment(this.startTime).valueOf()
      } else {
        this.queryParams.start_time = null
      }
      if(this.endTime) {
        this.queryParams.end_time = moment(this.endTime).valueOf()
      } else {
        this.queryParams.end_time = null
      }
      if(this.startTime > this.endTime) {
        Message.error('开始时间不可大于结束时间')
        return
      }
      this.getList()
      this.getCount()
    },
    search () {
      this.queryParams.skip = 0
      this.currPage = 1
      this.refresh()
    },
    currPageChange (currPage) {
      this.queryParams.skip = (currPage - 1) * this.queryParams.limit
      this.getList()
    },
    viewDetail (item) {
      console.log(item)
      this.deviceDialogVisible = true
      this.isShowBuzzAudioType.forEach(t => {
        if(t.value == item.audio_type) {
          this.currEditSubTypeList = t.subType
        }
      })
      /**
       * remark_type === -2 时 音频类型是 audio_type
       * remark_type !== -2 时 音频类型是 remark_type
       */
      // if(item.remark_type !== -2) {
        for(let k in this.currViewDetailData) {
          this.currViewDetailData[k] = item[k]
        }
        for(let k in this.editPostParams) {
          this.editPostParams[k] = item[k]
        }
      // } else {
      //   for(let k in this.currViewDetailData) {
      //     this.currViewDetailData[k] = null
      //   }
      //   for(let k in this.editPostParams) {
      //     this.editPostParams[k] = null
      //   }
      //   this.currViewDetailData.id = item.id
      //   this.currViewDetailData.audio_path = item.audio_path
      // }
    },
    dateChange (e) {
      // console.log(e)
      // if(e) {
      //   this.deviceAudioParams.start_time = moment(e).valueOf()
      //   this.deviceAudioParams.end_time = this.deviceAudioParams.start_time + this.oneDayTime
      //   this.getDeviceAudio()
      // }
      if(e) {
        this.queryParams.start_time = moment(e[0]).valueOf()
        this.queryParams.end_time = moment(e[1]).valueOf()
      } else {
        this.queryParams.start_time = ''
        this.queryParams.end_time = ''
      }
    },
    startDateChange (e) {
      console.log(e)
    },
    getDevices () {
      getDevicesApi({skip: 0, limit: 10000, hennery_id: this.queryParams.hennery_id}).then(res=>{
        let data = res.data.data.devices
        this.devices = []
        data.forEach(item => {
          let name = !!item.custom_name ? item.custom_name : item.hostname
          this.devices.push({
            id: item.id,
            name
          })
        })
      })
    },
    // getBuildingListApi
    getBuildings () {
      getBuildingListApi({skip: 0, limit: 10000, hennery_id: this.queryParams.hennery_id}).then(res=>{
        this.buildings = res.data.data.buildings.sort((a, b) => a.name.localeCompare(b.name))
      })
    },
  },
  watch: {

  },
  created(){
    // let params = this.$route.params
    // if(!!params.id) {
    //   this.currHenneryId = params.id
    // }
    // if(!!params.name) {
    //   this.currHenneryName = params.name
    // }
    this.$store.commit('setCurrHenneryId', this.$route.params.id)
    this.refresh()
    this.getDevices()
    this.getBuildings()
  },
  beforeDestroy () {
    if(this.newNormalizeAudio) this.newNormalizeAudio.close()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import 'poultry.scss';
.audio-icon {
  padding: 0px 0 20px;
  text-align: center;
  color: #017dfa;
  cursor: pointer;
  .audio-pro {
    display: flex;
    align-items: center;
    .audio-pro-left {
      // width: 12.7%;
    }
    .audio-pro-center {
      // width: 61.8%;
      position: relative;
      .slider {
        width: 100%;
        height: 6px;
        margin: 24px 0;
        background-color: #E4E7ED;
        border-radius: 3px;
        position: relative;
        cursor: pointer;
        vertical-align: middle;
        .bar {
          height: 6px;
          border-top-left-radius: 3px;
          border-bottom-left-radius: 3px;
          position: absolute;
          background-color: #017dfa;
          left: 0;
        }
        .btn {
          height: 36px;
          width: 36px;
          position: absolute;
          z-index: 1001;
          top: -15px;
          transform: translateX(-50%);
          -webkit-transform: translateX(-50%);
          background-color: transparent;
          text-align: center;
          -webkit-user-select: none;
          -moz-user-select: none;
          -ms-user-select: none;
          user-select: none;
          line-height: normal;
          padding: 6px;
          i {
            display: inline-block;
            width: 24px;
            height: 24px;
            border: 2px solid #017dfa;
            background-color: #FFF;
            border-radius: 50%;
            transition: .2s;
            // vertical-align: middle;
            user-select: none;
          }
        }
      }
      .audio-progress-txt {
        position: absolute;
        left: 0;
        bottom: -15px;
        width: 100%;
        text-align: center;
        color: #ffffff;
      }
    }
    .audio-pro-right {
      padding-left: 30px;
    }
  }
  i {
    font-size: 56px;
  }
  
}
.audio-spectrogram {
  position: relative;
  line-height: 0;
  .audio-interest-region {
    width: 40px;
    height: 30px;
    border: 1px solid #fff;
    position: absolute;
    bottom: 20%;
    left: 50%;
    border-radius: 50%;
  }
  .audio-spectrogram-region {
    width: 62%;
    height: 77%;
    position: absolute;
    bottom: 11%;
    left: 12.7%;
    background-color: rgba(0,0,0, 0.9);
  }
  .audio-region {
    width: 0;
    height: 77%;
    position: absolute;
    bottom: 11%;
    left: 0;
    background-color: rgba(255,255,255, 0.25);
  }
  .audio-vernier {
    width: 1px;
    height: 77%;
    position: absolute;
    bottom: 11%;
    left: 12.7%;
    background-color: rgba(0,255,255, 0.6);
    // transition: left 0.25s linear 0s;
    // -webkit-transition: left 0.25s linear 0s;
    // -moz-transition: left 0.25s linear 0s;
    // -o-transition: left 0.25s linear 0s;
  }
}
</style>
